"use strict";

var _articleFreeReadsRedirect = _interopRequireDefault(require("../components/article-free-reads-redirect"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Blog
 * ------------------------------------------------------------------------------
 *
 * @namespace blog
 */


document.addEventListener('DOMContentLoaded', function () {
  (0, _articleFreeReadsRedirect["default"])().init();
});